/*
 * 礼物分成详情
 */
import React, { useState, useEffect } from 'react'
import * as R from 'ramda'
import classnames from 'classnames';
import { Paragraph } from 'antd'
import styles from '../style.scss?__local';
import { getGiftShareConfigContent } from '@/api/api'
import { useAction } from '@/hooks/useAction'

export default function GiftShareDetail({ extUuid }) {
  const [{ isLoading, respData, error }, fetchContent] = useAction(getGiftShareConfigContent, { notifyError: false })

  useEffect(() => {
    fetchContent(extUuid)
  }, [])

  if (!respData || !respData.content || !respData.needShow) return null

  // <p style="margin-bottom: 0;"><span>该弹幕互动玩法由第三方公司提供，该程序的相关权利义务由该公司享有与承担。在启用该互动玩法期间，使用指定互动礼物将产生特殊游戏效果，主播与公会将共计获得指定互动礼物</span><span style="color: rgb(255, 0, 0);">40%</span><span>的流水收益。</span></p>
  return <>
    <div className={styles['app-sec']}>
      <div className={styles['app-sec-tit']}>使用须知：</div>
      <div dangerouslySetInnerHTML={{
        __html: respData.content
      }}>
      </div>
    </div>

    <div className={styles['app-sec-line']}></div>
  </>
}
